import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BrandService } from 'app/services/models/brand.service';
import { CategoryService } from 'app/services/models/category.service';
import { CurrencyService } from 'app/services/models/currency.service';
import { KindService } from 'app/services/models/kind.service';
import { LabelService } from 'app/services/models/label.service';
import { ProductVariantDefinitionService } from 'app/services/models/product-variant-definition.service';
import { ProductVariantService } from 'app/services/models/product-variant.service';
import { ProductService } from 'app/services/models/product.service';
import { TaxService } from 'app/services/models/tax.service';
import { UnitTypeService } from 'app/services/models/unit-type.service';
import { WarehouseService } from 'app/services/models/warehouse.service';
import Stepper from 'bs-stepper';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-update-product-dialog',
  templateUrl: './update-product-dialog.component.html',
  styleUrls: ['./update-product-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UpdateProductDialogComponent implements OnInit {
  @Input() data: { productType: boolean; productId: number };
  productForm: FormGroup;
  newLabel: string = '';
  public selectBasicLoading = false;
  private verticalWizardStepper: Stepper;

  public unitTypes: [];
  public currencies: [];
  public taxes: [];
  public categories: [];
  public warehoueses: [];
  brands: any[];
  kinds: any[];
  productType: boolean;
  selectedVaryants: any[];
  product: any = {};
  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private productService: ProductService,
    private kindService: KindService,
    private unitTypeService: UnitTypeService,
    private currencyService: CurrencyService,
    private taxService: TaxService,
    private categoryService: CategoryService,
    private warehouseService: WarehouseService,
    private brandService: BrandService,
    private toastrService: ToastrService,
    private labelService: LabelService,
    private varyantDefinitionService: ProductVariantDefinitionService,
    private productVariantService: ProductVariantService
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.loadDropdowns();

    this.verticalWizardStepper = new Stepper(document.querySelector('#stepper2'), {
      linear: false,
      animation: true
    });

    if (this.data?.productId) {
      this.loadProduct(this.data.productId);
    }
    this.productForm.get('productType')?.valueChanges.subscribe((value: boolean) => {
      this.productType = value;
    });
    this.productForm.get('productType')?.valueChanges.subscribe((value: boolean) => {
      const kindIdControl = this.productForm.get('kindId');
      if (value === false) {
        kindIdControl?.setValidators([Validators.required]);
      } else {
        kindIdControl?.clearValidators();
      }
      kindIdControl?.updateValueAndValidity();
    });
    this.productForm.markAllAsTouched();

  }

  initForm() {
    this.productForm = this.fb.group({
      name: ['', Validators.required],
      barcode: [''],
      productType: [true],
      code: [''],
      purchasePrice: [0],
      salePrice: [0],
      purchaseTaxId: [null],
      saleTaxId: [null],
      currencyId: [null],
      kindId: [null],
      categoryId: [null],
      criticalStock: [0],
      unitTypeId: [null],
      brandModelId: [null],
      labels: [[]],
      updateProductVaryantDtos: []
    });

  }

  async loadProduct(id: number) {
    await this.getAllUnitTypes(0, 100, "");
    await this.getAllCurrency(0, 100, "");
    await this.getAllTax(0, 100, "");
    await this.getAllCategory(0, 100, "");
    await this.getAllWarehouse(0, 100, "");
    await this.getAllBrand();
    await this.getAllKinds();
    await this.getAllVaryant();
    const product = await this.productService.getByIdProduct(id);
    console.log(product);
    this.product = product;
    this.selectedVaryants = this.product?.productVaryants;
    this.productForm.patchValue({
      name: product.name,
      barcode: product.barcode,
      productType: product.productType,
      code: product.code,
      purchasePrice: product.purchasePrice,
      salePrice: product.salePrice,
      purchaseTaxId: product.purchaseTaxId,
      saleTaxId: product.saleTaxId,
      currencyId: product.currencyId,
      kindId: product.kindId,
      categoryId: product.categoryId,
      criticalStock: product.criticalStock,
      unitTypeId: product.unitTypeId,
      brandModelId: product.brandModelId,
      labels: product.labels
    });

  }

  varyants: any[];

  async getAllVaryant() {
    const data = await this.varyantDefinitionService.getAllProductVariantDefinition();
    console.log(data);
    this.varyants = data;
  }

  async getAllKinds() {
    const data = await this.kindService.getAllKinds('', 0, 100, 13);
    this.kinds = data.types;
  }
  async getProductVaryantValues(id: number) {
    console.log('%c📡 getProductVaryantValues çağrıldı:', 'color: cyan;', id);
    try {
      const data = await this.productVariantService.getProductVaryantValues(id);
      console.log('%c✅ API cevabı:', 'color: lightgreen;', data);
      return data;
    } catch (err) {
      console.error('%c❌ API hatası:', 'color: red;', err);
      return [];
    }
  }

  varyantCache = new Map<number, any[]>();
  async onVariantSelectChange() {
    if (!this.product.productVaryants) {
      this.product.productVaryants = [];
    }

    for (const sel of this.selectedVaryants) {
      // Varyant zaten ekli mi?
      const existing = this.product.productVaryants.find(v => v.name === sel.name);
      if (!existing) {
        const fullVariant = this.varyants.find(v => v.id === sel.id);
        const variantType = fullVariant?.variantType || 1;

        const newVariant: any = {
          id: 0,
          name: sel.name,
          ProductVariantDefinitionId: sel.id,
          productId: this.product.id,
          isActive: true,
          isRequired: false,
          displayOrder: this.product.productVaryants.length + 1,
          variantType: variantType,
          productVariantOptions: [],
          trueLabel: null,
          falseLabel: null
        };

        // Eğer type 1 ise ve cache’de veri varsa options ekle
        if (variantType === 1) {
          let options: any[] = [];

          // Cache kontrolü
          if (this.varyantCache.has(sel.id)) {
            options = this.varyantCache.get(sel.id) || [];
          } else {
            // API’den al ve cache’e ekle
            options = await this.getProductVaryantValues(sel.id);
            this.varyantCache.set(sel.id, options);
          }

          // options ekle
          if (options.length) {
            newVariant.productVariantOptions = options.map(o => ({
              id: null,
              name: o.optionValue,
              count: o.count
            }));
          }
        }

        this.product.productVaryants.push(newVariant);
      }
    }

    // Artık seçilmeyenleri sil
    this.product.productVaryants = this.product.productVaryants.filter(v =>
      this.selectedVaryants.some(sel => sel.name === v.name)
    );

    console.log(this.product.productVaryants);
  }

  dropVariant(event: CdkDragDrop<any[]>) {
    // 1️⃣ Array içindeki öğeleri sıraya göre taşı
    moveItemInArray(this.product.productVaryants, event.previousIndex, event.currentIndex);
    // 2️⃣ displayOrder'u güncelle
    this.product.productVaryants.forEach((v, i) => v.displayOrder = i + 1);
  }

  // optionlar arası sıralama
  dropOption(varyant: any, event: CdkDragDrop<any[]>) {
    moveItemInArray(varyant.productVariantOptions, event.previousIndex, event.currentIndex);
    varyant.productVariantOptions.forEach((o, i) => (o.displayOrder = i + 1));
  }

  getVariantType(varyant: any): number {
    // tip id’si backend’de productVariantDefinitionId olabilir
    if (varyant.variantType === 1) return 1;
    if (varyant.variantType === 2) return 2;
    if (varyant.variantType === 3) return 3;
    return 1;
  }

  // aktif/pasif değiştir
  toggleActive(varyant: any) {
    varyant.isActive = !varyant.isActive;
  }

  // varyant sil
  removeVaryant(index: number) {
    this.product.productVaryants.splice(index, 1);
    this.product.productVaryants.forEach((v, i) => (v.displayOrder = i + 1));
  }

  // option ekle/sil
  addOption(varyant: any) {
    varyant.productVariantOptions.push({
      id: 0,
      name: '',
      displayOrder: varyant.productVariantOptions.length + 1,
    });
  }

  removeOption(varyant: any, index: number) {
    varyant.productVariantOptions.splice(index, 1);
    varyant.productVariantOptions.forEach((o, i) => (o.displayOrder = i + 1));
  }

  async getAllUnitTypes(page, size, search) {
    this.selectBasicLoading = true;
    const data = await this.unitTypeService.getAllUnitType(0, 100, search);
    console.log(data.unitTypes);
    this.unitTypes = data.unitTypes
    this.selectBasicLoading = false;
  }

  async getAllCurrency(page, size, search) {
    this.selectBasicLoading = true;
    const data = await this.currencyService.getAllPageCurrency(page, size, search);
    console.log(data);
    this.currencies = data.currenies
    this.selectBasicLoading = false;
  }

  async getAllTax(page, size, search) {
    this.selectBasicLoading = true;
    const data = await this.taxService.getAllTax(0, 100, search);
    console.log(data);
    this.taxes = data.taxex
    this.selectBasicLoading = false;

  }

  async getAllCategory(page, size, search) {
    this.selectBasicLoading = true;
    const data = await this.categoryService.getAllCategory(0, 100, search, 1);
    console.log(data);
    this.categories = data.categories;
    this.selectBasicLoading = false;

  }

  async getAllWarehouse(page, size, search) {
    this.selectBasicLoading = true;
    const data = await this.warehouseService.getAllWarehouses(0, 100, search);
    console.log(data);
    this.warehoueses = data.warehouses;
    this.selectBasicLoading = false;
  }

  async getAllBrand() {
    const data = await this.brandService.getBrands();
    // flatMap kullanarak tek katmanlı bir dizi oluşturuyoruz
    this.brands = data.flatMap(brand =>
      brand.brandModels.map(model => ({
        id: model.id,                // Modelin ID'sini ekliyoruz
        name: model.modelName,        // Model ismi
        brandName: brand.brandName    // Grup başlığı olarak marka ismi
      }))
    );
    console.log(this.brands);
  }


  loadDropdowns() {
    // dropdown verilerini servislerden çek
    // örnek: this.currencies = await this.productService.getCurrencies();
  }

  addLabel(event: KeyboardEvent) {
    event.preventDefault();
    const label = { labelName: this.newLabel, productLabelId: Date.now() };
    const labels = this.productForm.get('labels')?.value || [];
    this.productForm.get('labels')?.setValue([...labels, label]);
    this.newLabel = '';
  }

  async onSubmit() {
    console.log(this.product);
    if (this.productForm.valid) {
      const payload = this.product.productVaryants.map(v => ({
        id: v.id,
        isRequired: v.isRequired,
        productVariantDefinitionId: v.ProductVariantDefinitionId ?? null,
        productId: this.product.id ?? null,
        isActive: v.isActive,
        displayOrder: v.displayOrder,
        trueLabel: v.trueLabel,
        falseLabel: v.falseLabel,
        updateProductVariantOptionDTOs: v.productVariantOptions.map(o => ({
          id: o.id || 0,
          name: o.name, // DTO’da var, okey
          value: o.value || null,
          displayOrder: o.displayOrder || 0
        }))
      }));
      console.log(payload);
      const formData = this.productForm.value;
      const result = await this.productService.updateProduct({
        id: this.data.productId,
        code: formData.code,
        barcode: formData.barcode,
        name: formData.name,
        productType: formData.productType,
        purchasePrice: formData.purchasePrice,
        salePrice: formData.salePrice,
        purchaseTaxId: formData.purchaseTaxId,
        saleTaxId: formData.saleTaxId,
        categoryId: formData.categoryId,
        criticalStock: formData.criticalStock,
        unitTypeId: formData.unitTypeId,
        currencyId: formData.currencyId,
        labels: formData.labels.map(label => label.labelName),
        brandModelId: formData.brandModelId,
        kindId: formData.kindId,
        updateProductVaryantDtos: payload
      });
      if (result.status == true) {
        this.toastrService.success(result.message);
        this.activeModal.close(true);
      } else {
        this.toastrService.error(result.message);
      }
    }
  }

  async removeLabel(productLabelId: number) {
    this.productForm.value.labels = this.productForm.value.labels.filter(label => label.labelId !== productLabelId);

    // Optionally call the backend API to remove the label
    await this.removeLabelFromBackend(productLabelId);
  }


  async removeLabelFromBackend(labelId: number) {
    console.log(labelId);
    const data = await this.labelService.removeLabelProduct(labelId);
    if (data.status) {
      this.loadProduct(this.data.productId);
    }
  }

  close() {
    this.activeModal.dismiss();
  }

  verticalWizardNext() {
    this.verticalWizardStepper.next();
  }
  /**
   * Vertical Wizard Stepper Previous
   */
  verticalWizardPrevious() {
    this.verticalWizardStepper.previous();
  }
}
